import { FT } from 'ft'

class BGM {
  constructor() {
    this.currentBGM = null
  }

  playIntro() {
    const name = 'sound.bgm-intro'

    if (!this.currentBGM || this.currentBGM.name !== name) {
      if (this.currentBGM) {
        this.currentBGM.stop()
      }

      const sound = FT.rm.sound(name)
      sound.name = name
      this.currentBGM = sound
      sound.play()
    }
  }

  playBedroom() {
    const name = 'sound.bgm-bedroom'

    if (!this.currentBGM || this.currentBGM.name !== name) {
      if (this.currentBGM) {
        this.currentBGM.stop()
      }

      const sound = FT.rm.sound(name)
      sound.name = name
      sound.loop = true
      this.currentBGM = sound
      sound.play()
    }
  }

  get env() {
    const sound = FT.rm.sound('sound.env')
    sound.loop = true
    return sound
  }
}

export default new BGM()
